<template>
    <rkm-table
        :fields="fields"
        :items="data.model.problemasCondicoesOutros"
        hide-filters
        hide-pagination
    >
        <template v-slot:cell(ciap)="{item}">
            {{ item.ciap ? `${item.ciap.codigo} - ${item.ciap.descricao}` : '-' }}
        </template>

        <template v-slot:cell(cid)="{item}">
            {{ item.cid ? `${item.cid.codigo} - ${item.cid.nome}` : '-' }}
        </template>

        <template v-slot:cell(actions)="{index, item}">
            <rkm-button
                @click="$emit('edit', item)"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="destroy(index)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    data: () => ({
        fields: [
            {key: 'ciap', label: 'CIAP 2', sortable: true},
            {key: 'cid', label: 'CID 10', sortable: true},
            {key: 'situacaoNome', label: 'Situação', sortable: true},
            {key: 'observacao', label: 'Observação'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o problema/condição?', async () => {
                this.data.model.problemasCondicoesOutros.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
